import { NotificationMessage, RequestErrorMessages } from '../../../hooks/useClient';
import { Reservation } from '../../../types/reservation';

export const getPanelTitle = (
  isCreating: boolean,
  isEditing: boolean,
  reservationTypeName: string | undefined,
  reservation?: Reservation,
): string => {
  const blockedText = reservation?.blocked ? ' (Bloqueada)' : '';

  if (!isCreating && isEditing && reservationTypeName) {
    const now = new Date();
    const startDate = reservation?.localStartDate ? new Date(reservation.localStartDate) : null;
    if (startDate && startDate <= now) {
      return `Asistencias de ${reservationTypeName}`;
    }
    return `Editar reserva de ${reservationTypeName}`;
  }
  if (!isCreating && !isEditing) {
    return `Detalle de reserva de ${reservationTypeName}${blockedText}`;
  }
  if (isCreating && !isEditing) {
    return `Crear reserva de ${reservationTypeName}`;
  }
  return `Reserva de ${reservationTypeName}`;
};

export const getToastMessages = (
  isEditing: boolean,
  isGroupReservation: boolean,
): {
  successMessage: NotificationMessage;
  errorMessages: RequestErrorMessages;
} => {
  return {
    successMessage: {
      summary: isEditing ? 'Reserva modificada' : 'Reserva creada',
      detail: isEditing ? 'La reserva se ha modificado correctamente' : 'Se ha creado una nueva reserva',
    },
    errorMessages: {
      summary: isEditing ? 'Error modificando la reserva' : 'Error al crear la reserva',
      defaultDetail: isEditing ? 'No se ha podido modificar la reserva' : 'No se ha podido crear la reserva',
      EXTERNAL_USER_HAS_CONFLICTING_RESERVATIONS: isGroupReservation
        ? 'Uno de los clientes ya tiene una reserva en este horario'
        : 'El cliente ya tiene una reserva en este horario',
      RESERVATION_IS_IN_REST_HOUR: 'El horario seleccionado está en hora de descanso.',
      RESERVATION_IS_OUTSIDE_ALLOWED_HOURS: 'El horario seleccionado está fuera de las horas permitidas.',
      BRANCH_HAS_CONFLICTING_RESERVATION:
        'La reserva no se puede crear porque entra en conflicto con otra de la misma sucursal..',
      COUPON_NOT_ENOUGH_USES: 'El bono seleccionado no tiene usos disponibles.',
    },
  };
};
